import React from 'react';
import ReactDOM from 'react-dom';


export default function About() {
  return (
    <div>This is the monkey scripts about page! I do a bunch of about things in here wooo!</div>
  )
}